import React, { useEffect, useState } from 'react'
import { FaChevronCircleLeft, FaPlus } from 'react-icons/fa'
import { useNavigate } from 'react-router'
import { DefaultcabinetInterface, ShowCabinetContext, cabinetInterface } from './types'
import DataCabinet from './DataCabinet'
import { useDispatch } from 'react-redux'
import { getCabinetsApi } from '../../redux/cabinets/cabinetApiCalls'
import { getDoctorsApi } from '../../redux/doctors/doctorApiCalls'
import SuccessMsg from '../../Messages/SuccessMsg'
import DeleteCabinet from './DeleteCabinet'
import { getMedecinTypesApi } from '../../redux/medecinType/medecinTypeApiCalls'
import { getMoughataasApi } from '../../redux/moughataas/moughataaApiCalls'

const ShowCabinet = () => {
  const [showSuccessMsg, setShowSuccessMsg] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [selectedCabinet, setSelectedCabinet] = useState<cabinetInterface>(DefaultcabinetInterface)
  const navigate = useNavigate()

  const dispatch: any = useDispatch()

  useEffect(() => {
    const fetchAPIs = async () => {
      await dispatch(getCabinetsApi())
      await dispatch(getDoctorsApi())
      await dispatch(getMedecinTypesApi())
      await dispatch(getMoughataasApi())
    }
    fetchAPIs()
  }, [dispatch])

  return (
    <ShowCabinetContext.Provider value={{
      showSuccessMsg, setShowSuccessMsg,
      showDeleteModal, setShowDeleteModal,
      selectedCabinet, setSelectedCabinet
    }}>
      {/* Success Message */}
      <SuccessMsg modal={showSuccessMsg} toggle={() => setShowSuccessMsg(!showSuccessMsg)} />

      {/* Header Actions */}
      <div className="flex items-center gap-3 mb-4">
        <button
          title="Retour"
          onClick={() => navigate("/")}
          className="p-2 rounded-full btn-main"
        >
          <FaChevronCircleLeft className="text-xl" />
        </button>

        <button
          title="Ajouter un cabinet"
          onClick={() => navigate("create")}
          className="p-2 rounded-full btn-second"
        >
          <FaPlus className="text-xl" />
        </button>
      </div>

      {/* Main Content */}
      <DataCabinet />

      {/* Delete Modal */}
      {showDeleteModal && (
        <DeleteCabinet
          modal={showDeleteModal}
          toggle={() => setShowDeleteModal(!showDeleteModal)}
        />
      )}
    </ShowCabinetContext.Provider>
  )
}

export default ShowCabinet
